import { ColumnDef } from '@3ddv/software-division-components/backoffice/table';
import { gsActionsColumn } from '../../shared/ui/table/gs-table.columns';
import { RedisRecord } from './models/redis-manager.model';

export function buildRedisColumns(
  onView: (record: RedisRecord) => void,
  onDelete: (key: string) => void
): ColumnDef<RedisRecord>[] {
  const keyColumn: ColumnDef<RedisRecord> = {
    id: 'key',
    header: 'Key',
    accessorFn: record => record.key,
  };

  const actionsColumn = gsActionsColumn<RedisRecord>({
    actions: [
      {
        id: 'view',
        label: 'View',
        dataCy: record => `redis-eye-button-${record.key}`,
      },
      {
        id: 'delete',
        label: 'Delete',
        destructive: true,
        dataCy: record => `redis-delete-button-${record.key}`,
      },
    ],
    onSelect: (actionId, record) => {
      if (actionId === 'view') {
        onView(record);
      } else if (actionId === 'delete') {
        onDelete(record.key);
      }
    },
    rowDataCy: record => `redis-row-${record.key}`,
  });

  return [keyColumn, actionsColumn];
}
